import { useSelector } from "react-redux";

const useTransports = () => {
    const transports = useSelector((state) => state.transports);
    return transports;
};

export default useTransports;